type TTimestamp = string

const setNextDay = (currentDate: Date, currentDay: number) => {
  const currentMonth = currentDate.getMonth()
  const currentYear = currentDate.getFullYear()
  
  // Последний день февраля (28 или 29)
  const lastDayOfFebruary = new Date(currentYear, 2, 0).getDate()
  
  // Даты зачисления: 10, 20, 30/lastDayOfFebruary
  const admissionDays = currentMonth === 1 ? [10, 20, lastDayOfFebruary] : [10, 20, 30]
  
  // Найти следующую дату зачисления
  for (const day of admissionDays) {
    if (currentDay <= day) {
      currentDate.setDate(day)
      return
    }
  }
  
  // Если прошли все даты текущего месяца, берем 10 число следующего
  currentDate.setMonth(currentMonth + 1, 10)
}

const getNearestTuesday = (date: Date) => {
  const dayOfWeek = date.getDay() // 0 = вс, 1 = пн, 2 = вт
  const diff = (2 - dayOfWeek + 7) % 7 // если сегодня вторник → 0, остаемся на сегодня
  if (diff !== 0) {
    date.setDate(date.getDate() + diff)
  }
  return date
}

export const calculateClosestEnrollment = ({
  timestamp,
  months,
  locale,
  isCourse
}: {
  timestamp?: TTimestamp | null
  months: readonly string[]
  locale: string | undefined
  isCourse?: boolean
}) => {
  const isDateTimestamp = timestamp && Date.parse(timestamp) > Date.now()

  const date = isDateTimestamp ? new Date(timestamp) : new Date()
  // const date = isDateTimestamp ? new Date(timestamp) : new Date(2026, 0, 20) // custom date for enrollment

  if (!isDateTimestamp) {
    if (isCourse) {
      getNearestTuesday(date)
    } else {
      setNextDay(date, date.getDate())
    }
  }

  return !locale || ['ru', 'en'].includes(locale)
    ? isDateTimestamp
      ? date.toLocaleString(locale, {
          day: 'numeric',
          month: 'long',
          year: 'numeric'
        })
      : date
          .toLocaleString(locale, {
            day: 'numeric',
            month: 'long',
          })
          .replace(' г.', '')
    : `${date.getDate()} ${months[date.getMonth()]}`
}
